import { useState, useCallback } from 'react';

// 'web' (sidebar) or 'app' (bottom-nav, tablet/mobile-style). Persisted per device once the
// user picks one explicitly; until then it auto-follows screen width so phones/tablets land
// on the app version and desktops land on web by default.
//
// Auto-detection only runs once, at load — it deliberately does NOT keep watching window
// resize. Flipping the entire shell (sidebar <-> bottom-nav) mid-drag while someone is
// resizing their browser is jarring and fights any CSS-driven responsive layout (like the
// Settings page's own nav, which reflows continuously via media queries). One decision per
// page load, made instantly re-checkable via the manual toggle, is more predictable.
const BREAKPOINT = 900;

const computeDefault = () => (window.innerWidth < BREAKPOINT ? 'app' : 'web');

// storageKey defaults to the admin CRM's original key ('viewMode') for backward
// compatibility; the customer portal passes its own key so the two don't share state
// (an admin and a customer signed in on the same browser shouldn't affect each other).
export function useViewMode(storageKey = 'viewMode') {
  const [viewMode, setViewMode] = useState(() => localStorage.getItem(storageKey) || computeDefault());

  const toggleViewMode = useCallback(() => {
    setViewMode(v => {
      const next = v === 'web' ? 'app' : 'web';
      localStorage.setItem(storageKey, next);
      return next;
    });
  }, [storageKey]);

  return { viewMode, toggleViewMode };
}
